import { render, staticRenderFns } from "./NewTransportationDocumentPage.vue?vue&type=template&id=104d009c&scoped=true"
import script from "./NewTransportationDocumentPage.vue?vue&type=script&lang=js"
export * from "./NewTransportationDocumentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104d009c",
  null
  
)

export default component.exports